export const lowercaseFirstLetter = (string: string) => {
    return string.charAt(0).toLowerCase() + string.slice(1);
};

export const safeAtob = (data?: string) => {
    if (!data) {
        return '';
    }
    try {
        return atob(data);
    } catch (error: unknown) {
        console.warn(error);
        return '';
    }
};
